class App {
	constructor() {
		this.imagePadder = document.querySelector( '.image-padder' );
		this.filterPosts = document.getElementsByClassName( 'filter-posts' );
		this.contactForms = document.querySelectorAll( 'a[href*="#contact"]' );

		this.listeners();
		this.init();
	}

	init() {
		if ( this.imagePadder ) {
			this.imagePadderHeight();
		}
		console.info( 'App Initialized' );
	}

	listeners() {
		var i;
		if ( this.imagePadder ) {
			window.addEventListener( 'resize', this.imagePadderHeight );
		}
		if ( this.filterPosts ) {
			for ( i = 0; i < this.filterPosts.length; i++ ) {
				this.filterPosts[i].addEventListener( 'click', this.filterPostsClick );
			}
		}
		if ( this.contactForms ) {
			for ( i = 0; i < this.contactForms.length; i++ ) {
				$( this.contactForms[i] ).attr( 'data-toggle', 'modal' );
				$( this.contactForms[i] ).attr( 'data-target', '#contactFormModal' );
			}
		}
	}

	imagePadderHeight() {
		var imageHeight;
		imageHeight = $( '.bleeding-image img' ).height();
		$( '.image-padder' ).css( 'height', `${imageHeight}px` );
	}

	filterPostsClick( e ) {
    var $this = $( this );
    var $posts = $( '.posts' );
		var nonce = $this.data( 'nonce' );
		var postType = $this.data( 'type' );
		var taxonomy = $this.data( 'taxonomy' );
		var term = $this.data( 'term' );
		$( '.list-group-item' ).removeClass( 'active' );
    $this.parent().addClass( 'active' );
    $( '#filter-posts-container' ).collapse( 'hide' );
    $posts.parent().addClass( 'loading' );
    $( '.content-filter' ).find( 'button span' ).fadeOut( 350, function() {
      $( this ).text( $this.text() ).fadeIn( 350 );
    } );

		e.preventDefault();
    e.stopPropagation();

    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'filterposts',
        nonce: nonce,
        postType: postType,
        taxonomy: taxonomy,
        term: term
      },
      type: 'POST',
      beforeSend: function( xhr ) {
        console.info( 'filtering starting...' );
      },
      success: function( response ) {
        var postOffset, totalPosts, percentage;
        var json = $.parseJSON( response );

        console.info( 'filtering done!' );
        $posts.parent().addClass( 'loaded' );

        setTimeout( function() {
          $posts.parent().removeClass( 'loading' );
        }, 500 );

        setTimeout( function() {
          $posts.parent().removeClass( 'loaded' );
          $posts.attr( 'data-total-results', json.total_results );
          $posts.html( json.html );

          postOffset = $( '.posts' ).children().length;
          totalPosts = json.total_results;
          percentage = ( postOffset / totalPosts ) * 100;

          if ( 100 < percentage ) {
            percentage = 100;
          }

          if ( 100 == percentage ) {
            $( 'a.load-more' ).attr( 'style', 'display: none !important;' );
          } else {
            $( 'a.load-more' ).removeAttr( 'style' );
          }
        }, 700 );
      }
    });
	}
}

export default App;
